import * as React from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useFeatureToggles, useClickAndReserveFeatureConfig, ClickAndReserveFeatureConfigEnum } from '@grandvisionhq/state';
import { pushCheckStoreAvailabilityClickEvent } from '../../Analytics/events/ClickAndReserveEvents.js';
import { ClickAndReserveProvider } from '../context/ClickAndReserveProvider.js';
import ClickAndReserveButton from './ClickAndReserveButtonContainer.js';
import { useProductWithAFrameData } from '../../../context/product-context-hooks.js';

const ClickAndReserveStoreFinderModal = /*#__PURE__*/ React.lazy(()=>import('./ClickAndReserveModalContainer.js')
);
const ClickAndReserveConfigurator = /*#__PURE__*/ React.lazy(()=>import('./ClickAndReserveConfigurator/ClickAndReserveConfigurator.js')
);
const ClickAndReserveStoreFinderWrapper = /*#__PURE__*/ React.lazy(()=>import('./ClickAndReserveStoreFinderWrapper/ClickAndReserveStoreFinderWrapper.js')
);
const Fallback = ()=>/*#__PURE__*/ React.createElement(LoaderScreen, {
        height: 100
    })
;
const ClickAndReserveContainer = ({ sku , onInvalidClick  })=>{
    const { featureConfigs , isClickAndReserveEnabled: isFeatureToggleEnabled  } = useFeatureToggles();
    const [isModalOpen, setModalOpen] = React.useState(false);
    const [hasInteracted, setHasInteracted] = React.useState(false);
    const clickAndReserveMode = useClickAndReserveFeatureConfig();
    const { activeVariant: { isReservable  } ,  } = useProductWithAFrameData();
    const handleOnButtonOnClick = React.useCallback(()=>{
        if (!!onInvalidClick) {
            onInvalidClick();
            return;
        }
        if (clickAndReserveMode) {
            pushCheckStoreAvailabilityClickEvent(clickAndReserveMode);
            setModalOpen(true);
            !hasInteracted && setHasInteracted(true);
        }
    }, [
        onInvalidClick,
        clickAndReserveMode,
        hasInteracted
    ]);
    const handleOnModalClose = React.useCallback(()=>{
        setModalOpen(false);
    }, [
        setModalOpen
    ]);
    var ref;
    const showClickAndReserveButton = isFeatureToggleEnabled && ((ref = featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.clickAndReserve) !== null && ref !== void 0 ? ref : '') in ClickAndReserveFeatureConfigEnum && isReservable;
    if (!showClickAndReserveButton) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("style", {
        jsx: true,
        global: true
    }, `
          .gm-style
            .gm-style-iw-c:has(
              .click-and-reserve-store-finder-item.stores-v2-store-finder-item--map-item.stores-v2-store-finder-item--disabled
            ) {
            background-color: var(--color--shade-lightest);
            padding: 0.75rem !important;
          }

          .gm-style
            .gm-style-iw-d:has(
              .click-and-reserve-store-finder-item.stores-v2-store-finder-item--map-item.stores-v2-store-finder-item--disabled
            ) {
            overflow: hidden !important;
          }
        `), /*#__PURE__*/ React.createElement(ClickAndReserveButton, {
        onClick: handleOnButtonOnClick
    }), hasInteracted && clickAndReserveMode === 'stock_only' && /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Fallback, null)
    }, /*#__PURE__*/ React.createElement(ClickAndReserveStoreFinderWrapper, {
        sku: sku,
        key: sku
    }, /*#__PURE__*/ React.createElement(ClickAndReserveStoreFinderModal, {
        isOpen: isModalOpen,
        onModalClose: handleOnModalClose,
        sku: sku
    }))), hasInteracted && clickAndReserveMode === 'reservation' && /*#__PURE__*/ React.createElement(ClickAndReserveProvider, null, /*#__PURE__*/ React.createElement(React.Suspense, {
        fallback: /*#__PURE__*/ React.createElement(Fallback, null)
    }, /*#__PURE__*/ React.createElement(ClickAndReserveStoreFinderWrapper, {
        sku: sku,
        key: sku
    }, /*#__PURE__*/ React.createElement(ClickAndReserveConfigurator, {
        isOpen: isModalOpen,
        onModalClose: handleOnModalClose,
        sku: sku
    })))));
};
var ClickAndReserve = ClickAndReserveContainer;

export { ClickAndReserve as default };
//# sourceMappingURL=ClickAndReserveContainer.js.map
